import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {observer, PropTypes as MobxPropTypes} from 'mobx-react';
import * as mobx from 'mobx'

import {SearchToSelect} from "../../components";

import BingCategoryStore from './BingCategoryStore';

@observer
class BingCategorySelector extends Component {
  static propTypes = {
    placeholder: PropTypes.string,
    selected: MobxPropTypes.arrayOrObservableArray,
    onSelect: PropTypes.func.isRequired,
    multi: PropTypes.bool,
    disabled: PropTypes.bool,
    bingCategoriesStore: PropTypes.instanceOf(BingCategoryStore) // Can be supplied to remove reloading of categories
  };

  constructor(props){
    super(props);
  }

  componentWillMount(){
    if (!this.props.bingCategoriesStore.loaded) {
      this.props.bingCategoriesStore.loadCategories();
    }
  }

  render() {
    //for some reason placeholder was one draw behind
    const {selected, multi, disabled, bingCategoriesStore} = this.props;
    let placeholder;
    if (bingCategoriesStore.isLoading) {
      placeholder = "Loading..."
    } else if(multi && selected && selected.length){
      // Multi select displays category names
      const categories = mobx.toJS(this.props.bingCategoriesStore.categories);
      const names = selected.map(categoryText => {
        return categories.find(category => category.text.toLowerCase() === categoryText.toLowerCase())?.text;
      });

      placeholder = `${names.join(", ")}`;
    } else if (!multi && !!selected && selected.length > 0) {
      const categories = mobx.toJS(this.props.bingCategoriesStore.categories);
      placeholder = categories.find(categories => categories.text.toLowerCase() === selected[0].toLowerCase())?.text;
    }

    const jsCategories = mobx.toJS(bingCategoriesStore.categories);

    return (
      <SearchToSelect
        placeholder={this.props.placeholder || placeholder}
        maxItems={3}
        multi={multi}
        selectByKey
        disabled={disabled || bingCategoriesStore.isLoading}
        getKey={category => category.text}
        options={jsCategories}
        renderOption={category => category.text}
        renderMultiSelected={() => this.props.placeholder || placeholder || (multi ? "Categories" : "Category")}
        onSelected={this.props.onSelect}
        getSearchResults={({query}) => bingCategoriesStore.search(query)}
        selected={selected}
      />
    );
  }
}

BingCategorySelector.defaultProps = {
  multi: true, // Multi select by default
  disabled: false,
  bingCategoriesStore: new BingCategoryStore()
};

export default BingCategorySelector;